

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './User-panel/config/MsalConfig';



//REMOVE CONSOLE WARINGS 
if (process.env.NODE_ENV === "production") {

  console.warn = () => {};
  console.error = () => {};
}

console.warn = () => {};
console.error = () => {};



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
